import getFuncByMode from '../../utils/getFuncByMode';

import chuck from './chuck';
import mandi from './mandi';

export default getFuncByMode({
  chuck,
  mandi,
});
